<template>
  <v-dialog
    hide-overlay
    v-model="dialog"
    @keydown.esc="onDialogClose"
    persistent
    scrollable
    style="background-color: #f5f6fa"
  >
    <v-card flat color="#f5f6fa" height="650px">
      <v-card-text>
        <v-layout column class="main-layout">
          <v-flex class="pt-3 pb-2 px-3">
            <v-toolbar flat height="40px" style="background-color: #f5f6fa">
              <v-toolbar-title>
                <h3>Vessel schedule</h3>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn depressed icon class="mb-3">
                <v-icon color="#007BFF" @click="onDialogClose">fa-times</v-icon>
              </v-btn>
            </v-toolbar>
          </v-flex>
          <v-flex class="px-4 pb-2">
            <schedule-list v-model="selectedQuotation"></schedule-list>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="px-5">
        <v-spacer></v-spacer>
        <v-btn tile depressed class="btn-alt" @click="onDialogClose">Close</v-btn>
        <v-btn tile depressed class="btn-primary" @click="onSave" :disabled="!saveAllowed"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "../../const";

export default {
  props: ["quotation", "dialog"],

  data() {
    return {
      selectedQuotation: this.quotation,
      quotationUpdated: false,
      initialShipmentScheduleID: null,
    };
  },

  watch: {
    quotation: function () {
      this.selectedQuotation = this.quotation;
      this.quotationUpdated = false;

      if (
        this.selectedQuotation != null &&
        this.selectedQuotation.shipment_schedule != null
      ) {
        this.initialShipmentScheduleID = this.selectedQuotation.shipment_schedule.shipment_schedule_id;
      } else {
        this.initialShipmentScheduleID = null;
      }
    },
  },

  methods: {
    onDialogClose() {
      this.$emit(
        "dialog-close",
        constant.DIALOG_SCHEDULE_LIST,
        this.quotation,
        this.quotationUpdated
      );
    },

    onSave() {
      var response = null;
      this.$root.blockUImsg = "Assigning schedule to quotation...";
      this.$root.blockUIshow = true;

      this.$https
        .put(
          constant.API_HOST + "/api/quotations/" + this.selectedQuotation.quotation_id,
          this.selectedQuotation
        )
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          // console.log(response)
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.quotationUpdated = true;
            this.initialShipmentScheduleID = this.selectedQuotation.shipment_schedule.shipment_schedule_id;
          } else {
            console.log("Error saving selected schedule", response);
          }
          this.$root.blockUIshow = true;
        });
    },
  },

  computed: {
    saveAllowed: {
      get() {
        // console.log(this.selectedQuotation != null &&
        //     this.selectedQuotation.shipment_schedule != null &&
        //     this.selectedQuotation.shipment_schedule.shipment_schedule_id != this.initialShipmentScheduleID)

        return (
          this.selectedQuotation != null &&
          this.selectedQuotation.shipment_schedule != null &&
          this.selectedQuotation.shipment_schedule.shipment_schedule_id !=
            this.initialShipmentScheduleID
        );
      },
    },
  },
};
</script>

<style></style>
